import axiosInstance from './http.api';
import { DEFAULT_ERROR_MSG} from '../utils/constants';

// Banner data interface
export interface BannerData {
    id: string,
    message:string,
    startDate:Date | null,
    endDate:Date | null,
    visibility : boolean
}

export const bannerService = {

  /**
   * Fetch Banners
   * @returns 
   */
  fetchBanners: async (): Promise<BannerData[]> => {
    try {
      const res = await axiosInstance.get<any>(`/v1/Banner`);

      if (!res.data.success) {
        throw new Error(res.data.message || DEFAULT_ERROR_MSG);
      }

      let data = res.data.data || [];

      const banners: BannerData[] = data.map((banner: any) => ({
        id: banner.id,
        firstName: banner.message,
        startDate: banner.startDate,
        endDate: banner.endDate,
        message: banner.message,
        visibility: banner.visibility
      }));
      return banners;
    } catch (error: any) {
      console.log(error);
      throw new Error(error?.response?.data?.message || DEFAULT_ERROR_MSG);
    }
  }
}